<p class="section-description">
  Mock resource statuses across all available status types. Pill labels swap based on context, so we render the table in
  both — Recovery (e.g. "Restoring", "Success") and Backup (e.g. "Backing Up", "Ready").
</p>
<h3 class="resource-status-subheader">Recovery context</h3>
<app-resources-view
  [resources]="statusResources"
  [tabType]="RecoveryTab"
  [statusContext]="StatusContext.RECOVERY"
  [loading]="false"
></app-resources-view>
<h3 class="resource-status-subheader">Backup context</h3>
<app-resources-view
  [resources]="statusResources"
  [tabType]="BackupTab"
  [statusContext]="StatusContext.BACKUP"
  [loading]="false"
></app-resources-view>

<h3 class="resource-status-subheader">Parent–child groups</h3>
<p class="section-description">
  Expandable parents (clusters, DB clusters, ASGs) with linked children. The "Needs attention" rollup pill replaces a
  parent's own pill only when a <em>descendant</em> needs attention — but a parent whose <em>own</em> status is a
  trigger state shows its real status pill instead. Expand each row to see its children. Both tables use the same data;
  row names describe the scenario.
</p>
<ul class="scenario-legend section-description">
  <li><strong>s1 AKS cluster (Failed)</strong> → shows <em>Failed</em>, not "Needs attention" (the bug fix)</li>
  <li><strong>s2 EKS cluster (Succeeded) + failed child</strong> → <em>Needs attention</em> + issue icon</li>
  <li><strong>s3 EKS cluster (Restoring) + failed child</strong> → <em>Needs attention</em></li>
  <li><strong>s4a AKS cluster (Not Processed)</strong> → own <em>Not Processed</em> pill</li>
  <li>
    <strong>s4b EKS cluster (Unsatisfied dependency)</strong> → own pill in <em>Recovery</em>, but
    <em>Needs attention</em> in <em>Backup</em> (recovery-only trigger)
  </li>
  <li><strong>s5 EKS cluster (No status) + failed child</strong> → <em>Needs attention</em> in both</li>
  <li><strong>s6 AKS cluster (Scan infected)</strong> → own pill in both contexts</li>
  <li><strong>s7 Aurora cluster, all healthy</strong> → own <em>Success</em> pill, no rollup, no issue icon</li>
  <li><strong>s8 EKS cluster (Succeeded) + in-flight children</strong> → promoted to <em>Restoring</em>, no rollup</li>
  <li><strong>s9 Auto Scaling Group + failed instance</strong> → <em>Needs attention</em> (common non-K8s group)</li>
</ul>
<h4 class="resource-status-subheader">Recovery context</h4>
<app-resources-view
  [resources]="parentChildResources"
  [tabType]="RecoveryTab"
  [statusContext]="StatusContext.RECOVERY"
  [loading]="false"
></app-resources-view>
<h4 class="resource-status-subheader">Backup context</h4>
<app-resources-view
  [resources]="parentChildResources"
  [tabType]="BackupTab"
  [statusContext]="StatusContext.BACKUP"
  [loading]="false"
></app-resources-view>
